import React from 'react';
import { string, bool, shape } from 'prop-types';
import { Grid } from '@material-ui/core';
import Link from 'gatsby-plugin-transition-link/AniLink';
import Icon from '../../Icon';
import styles from './style.module.scss';
import Image from '../../Image';

const CaseFooter = ({
  title,
  path,
  footerImg,
  casebg,
  color,
  isWeb,
}) => (
  <Link
    cover
    direction="left"
    duration={1}
    bg="#000"
    to={path}
    style={{ textDecoration: 'none' }}
  >
    <Grid
      container
      direction="column"
      justify="center"
      alignItems="center"
      className={styles.container}
    >
      <Grid item>
        <h2 className={styles.title}>{title}</h2>
      </Grid>
      <Grid item>

        <Grid container alignItems="center">
          <Grid item>
            <h4 style={{ cursor: 'pointer' }}>Next Project</h4>
          </Grid>
          <Icon type="rightArrow" style={{ marginLeft: 4 }} />
        </Grid>
      </Grid>
      <div
        className={[
          styles.containerImage,
          isWeb && styles.containerImageWeb,
          casebg && styles.containerBg,
        ].join(' ')}
        style={{
          backgroundColor: color,
          backgroundImage: `url(${casebg})`,
        }}
      >
        {
          !casebg && (
            <Image
              source={footerImg}
              className={[
                styles.image,
                isWeb && styles.imageWeb,
              ].join(' ')}
            />
          )
        }
      </div>
    </Grid>
  </Link>
);

CaseFooter.propTypes = {
  title: string,
  path: string,
  footerImg: shape({
    main: string,
    fall: string,
  }),
  isWeb: bool,
  color: string,
  casebg: string,
};

CaseFooter.defaultProps = {
  title: '',
  path: '',
  footerImg: null,
  isWeb: false,
  color: 'black',
  casebg: null,
};

export default CaseFooter;
